<template>
	<b-container class="pg-instruction-cont">
		<img
			class="pg-img-pos"
			src="../../assets/newdesign/dashboard/games/sudoku-haze.svg"
			alt=""
		/>
		<span class="pg-blue-txt d-flex w80">Sudoku Game Instructions</span>
		<h2 class="mt-3 mb-2">Objective :</h2>
		<h3>
			Fill the 9x9 grid so that each row, column, and 3x3 box contains the
			numbers<b> 1 to 9</b> without repeating.
		</h3>
		<h2 class="mt-3 mb-2">How to Play :</h2>
		<main class="d-flex pl-1">
			<h4 class="mr-1">1.</h4>
			<section>
				<h4>Start with Given Numbers :</h4>
				<h3>Some numbers are already placed in the grid.</h3>
			</section>
		</main>
		<main class="d-flex pl-1 mt-2">
			<h4 class="mr-1">2.</h4>
			<section>
				<h4>Fill Empty Cells :</h4>
				<h3>
					Place numbers 1 to 9 in the empty cells, ensuring no repeats in any
					row, column, or 3x3 box.
				</h3>
			</section>
		</main>
		<main class="d-flex pl-1 mt-2">
			<h4 class="mr-1">3.</h4>
			<section>
				<h4>Use Logic :</h4>
				<h3>
					Use the process of elimination and deduction to find the correct
					numbers.
				</h3>
			</section>
		</main>
	</b-container>
</template>

<script>
export default {};
</script>

<style></style>
